import * as React from "react";

function PhoneCallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M11.618 2H1.705l.3 3.304.002.013A27.57 27.57 0 006.365 17.25a29.41 29.41 0 008.385 8.385l.003.002a28 28 0 0011.926 4.356l.015.002 3.306.3v-9.913l-7.115-3.558-3.97 3.076-.096-.055a22.36 22.36 0 01-6.622-6.6l2.967-4.154L11.618 2zM3.995 5.096L3.895 4h6.487l2.454 4.909-3.03 4.243.645 1.076.008.013a24.36 24.36 0 007.3 7.3l.022.014 1.303.745 4.032-3.124L28 21.618v6.487l-1.094-.1a26 26 0 01-11.057-4.041 27.41 27.41 0 01-7.814-7.814 25.57 25.57 0 01-4.04-11.054zM19.507 2A10.56 10.56 0 0130 12.494l-2 .012A8.56 8.56 0 0019.494 4l.013-2zm-.012 5A5.48 5.48 0 0125 12.505l-2-.01A3.48 3.48 0 0019.504 9l-.009-2z",
    clipRule: "evenodd"
  }));
}

export default PhoneCallIcon;